import baseService from './baseService';

export const getOrganizations = () =>
  baseService.get('/organizations', {
    params: {
      member_app: 'member',
    },
  });

export function getFilterDropdownValuesService(organizationId) {
  return baseService.get(`/organizations/${organizationId}/jobs/new`);
}

export const getOrganizationByIdentifier = (organizationIdentifier) =>
  baseService.get(`/organizations/${organizationIdentifier}/retrieve_employer_profile`, {
    params: {
      member_app: 'member',
    },
  });

export const getOrganizationGeneralSignup = (identifier) =>
  baseService.get(`/organizations/${identifier}/general_settings/general_signup`);

export function getDropdownValues() {
  return baseService.get('/organizations/new');
}

export function createOrganization(data) {
  return baseService.post('/organizations', data);
}
